import { Learnable } from 'src/api/userScenario/types';

export const compare = (a: Learnable, b: Learnable) => {
  if (a.alreadyKnown) {
    return -1;
  }
  if (b.alreadyKnown) {
    return 1;
  }
  return b.growthLevel - a.growthLevel;
};
